export const state = {
  commissions: [],
  systemCommission: [],
  commission_items: [
    {
      description: "",
      amount: "",
      total_price: ""
    }
  ]
};
export default state;



// WEBPACK FOOTER //
// ./src/vuex/modules/commissions/state.js